import { render, staticRenderFns } from "./CPFooter.vue?vue&type=template&id=623ddd67&scoped=true&"
import script from "./CPFooter.vue?vue&type=script&lang=ts&"
export * from "./CPFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CPFooter.vue?vue&type=style&index=0&id=623ddd67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ddd67",
  null
  
)

export default component.exports